module.exports = __webpack_public_path__ + "static/media/checkin_approve.301afa6e.png";